// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"32e1388bc881d8545bb0","263":"6521e226c52cfcf3cca7","791":"55e206c7d59beae2517a"}[chunkId] + ".js";
};